function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` : null;
}

export function applyTheme() {
  const theme = window.__UMS_THEME__;
  if (!theme) return;
  const root = document.documentElement;
  if (theme.primaryColor) {
    root.style.setProperty('--brand-red', theme.primaryColor);
    root.style.setProperty('--ums-primary-red', theme.primaryColor);
    const rgb = hexToRgb(theme.primaryColor);
    if (rgb) root.style.setProperty('--brand-red-rgb', rgb);
  }
  if (theme.primaryColorHover) {
    root.style.setProperty('--brand-red-hover', theme.primaryColorHover);
    root.style.setProperty('--ums-primary-red-hover', theme.primaryColorHover);
  }
  if (theme.primaryColorLight) {
    root.style.setProperty('--light-cream', theme.primaryColorLight);
  }
  if (theme.portalTitle) document.title = theme.portalTitle;
  if (theme.faviconPath) {
    const link = document.querySelector("link[rel~='icon']");
    if (link) link.href = theme.faviconPath;
  }
}

export function getThemeColor(key, fallback) {
  const theme = window.__UMS_THEME__;
  if (!theme) return fallback;
  const map = {
    primary: theme.primaryColor,
    hover: theme.primaryColorHover,
    light: theme.primaryColorLight
  };
  return map[key] || fallback;
}
